import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Categories
 */
export const DeleteCategoryContentType = '' as const;
export type DeleteCategoryRequest = void;
export type DeleteCategoryResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': unknown;
    };
};
export type DeleteCategoryResponseSuccess = DeleteCategoryResponses['200']['application/json'];
export type DeleteCategorySearchParams = {
    with_variants?: boolean;
};
export type DeleteCategoryPathParameters = {
    id: string;
};
export const DeleteCategoryUrl = '/categories/{id}' as const;
export const DeleteCategoryMethod = 'DELETE' as const;
export const getDeleteCategoryUrl = (params: DeleteCategoryPathParameters) =>
    DeleteCategoryUrl.replace(/\{(\w+)\}/g, (_match, param: keyof DeleteCategoryPathParameters) =>
        String(params[param])
    );
